var ConfirmButton = (function() {
	var __private = {
		buttonTagName: "A", // TAG or false
		disabledClass: "btn-disabled",
		message: {
			className: "emailWasConfirm",
			html: "<i>Your confirmation email has been sent!</i>"
		},
		dataset: {
			url: "url"
		},

		listener() {
			document.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;
				var message;
				
				if(target instanceof HTMLElement) {
					
					new Promise((resolve, reject) => {
						if(target.dataset[__private.dataset.url] !== undefined && target.tagName === __private.buttonTagName) {
							event.preventDefault();

							target.classList.add(__private.disabledClass);

							message = target.parentElement.parentElement.getElementsByClassName(__private.message.className)[0];
							if(message instanceof HTMLElement) message.innerHTML = "";

							resolve();
						}
					})
						.then(() => {
							var data  = new FormData();
							var token = document.querySelector("meta[name='csrf-token']");

							data.append("_token", token.content);
							
							return data;
						})
						.then(data => {
							var url = target.dataset[__private.dataset.url];

							return Ajax.post(url, data);
						})
						.then(xhr => {
							var response = JSON.parse(xhr.response);
							target.classList.remove(__private.disabledClass);

							if(response.status === "OK") return true;
							else throw new Error(`${xhr.status} : ${xhr.statusText}`);
						})
						.then(() => {
							var block = target.parentElement;

							if(message instanceof HTMLElement)
								message.innerHTML = `<b><i>A confirmation email has been sent!</i></b>`;

							block.style.display = "none";
						});

				}
			});
		},

		createMessageElems() {
			var blocks = document.querySelectorAll(`a[data-${this.dataset.url}]`);
			var message;

			for (let i = 0; i < blocks.length; i++) {
				const block = blocks[i].parentElement;
				message = document.createElement("div");
				message.classList.add(this.message.className);

				block.parentElement.insertBefore(message, block);
			}
		}
	};

	return {
		init() {
			__private.createMessageElems();
			__private.listener();
		}
	};
})();


(function() {
	document.addEventListener("DOMContentLoaded", function() {
		ConfirmButton.init();
	});
})();